import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PublicRouter from "./PublicRouter";
import Login from "../app/modules/authentication/login-page/Login";
import SignUp from "../app/modules/authentication/signup-page/SignUp";
import ApplicationPage from "../app/modules/app-selection/ApplicationPage";
import UserControl from "../app/modules/user-control/UserControl";
import ForgotPassword from "../app/modules/authentication/forgot-password/ForgotPassword";
import UpdatePassword from "../app/modules/authentication/update-password/UpdatePassword";

export default function MainRoute() {
  return (
    <Routes>
      {/* Redirect from "/" to "/login" */}
      <Route path="/" element={<Navigate to="/login" />} />

      {/* Public Routes */}
      <Route path="/" element={<PublicRouter />}>
        <Route path="/login" element={<Login />} />
        <Route path="/user-control" element={<UserControl />} />
        <Route path="/applications" element={<ApplicationPage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/test" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/*" element={<h4>Error 404</h4>} />
      </Route>

      {/* Private Routes (Commented out for now) */}
      {/* <Route path="/" element={<PrivateRouter />}>
        <Route path="/*" element={<h4>Error 404</h4>} />
      </Route> */}
    </Routes>
  );
}
